import React from "react";
import ai from "../../../../../assets/img/ai-icon.svg";
import PropTypes from 'prop-types';

export default function ChatMessageAssistant({ message }) {
  return (
    <div className="d-flex align-items-start chat-conversation-row">
      <div className="chat-conversation-assistant">
        <img src={ai} alt={"ai"} />
      </div>
      <div className="chat-conversation-row-text text-justify">{message}</div>
    </div>
  );
}

ChatMessageAssistant.propTypes = {
  message: PropTypes.string.isRequired,
};